module.exports = __webpack_public_path__ + "static/media/login.59fc83e2.jpeg";